import { TextField } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledTextField = withStyles(theme => ({
  root: {
    width: '100%',
    padding: '0',
    margin: 'auto',

    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: theme.palette.grey[500]
      },

      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main
      }
    }
  }
}))(TextField)

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    minWidth: 200,

    '& div[class*="MuiOutlinedInput-root"]': {
      padding: '0px !important'
    },

    '& input': {
      paddingLeft: '32px !important',
      fontSize: theme.size.sm,
      height: 18
    }
  },

  textField: {
    width: '100%'
  },

  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  addTagBox: {
    cursor: 'pointer'
  },

  icon: {
    marginRight: '8px'
  },

  muiIcon: {
    height: 14,
    width: 14
  },

  inputIcon: {
    position: 'absolute',
    left: '10px'
  },

  menuItem: {
    fontSize: theme.size.base,
    fontFamily: '"Inter",sans-serif',

    '& svg': {
      marginRight: 7,
      height: 12,
      width: 12
    }
  }
}))

export default useStyles
